module.exports = __webpack_public_path__ + "3e2e0a625724e2168096cf3a3bc5fa58.svg";